module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-6_inactive-ac22aac421a7ed50dea540a5fb92ae3f.svg";